export default {
	field: 'categoryName',
	name: 'Category',
	width: '350px',
}
